import { Grid, Input, NativeSelect, Paper } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import Pagination from 'react-js-pagination';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../../components/Loading';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import { findPermission, TOKEN_PAGINATION } from '../../services/auth';
import '../Providers/pagination.style.css';
import useStyles from './style';

export function ProvidersGroup() {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [providers, setProviders] = useState([]);
  const [frequencies, setFrequencies] = useState([]);

  const [groupInput, setGroupInput] = useState('');
  const [cnpjCpfInput, setCnpjCpfInput] = useState('');
  const [status, setStatus] = useState('ativo');
  const [antecipacaoInput, setAntecipacaoInput] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
            color: rowData.corFonte ? rowData.corFonte : 'auto',
          })
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(1887, 'Alterar')) {
            window.location.href = window.location.origin + `/app/grupo-fornecedor/${rowData.grupoFornecedorId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'ID',
            field: 'grupoFornecedorId',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Grupo Fornecedor',
            field: 'grupo',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'CNPJ/CPF',
            field: 'raizCnpjCpf',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Frequência',
            field: 'frequencia',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(1887, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/grupo-fornecedor/${rowData.grupoFornecedorId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(1887, 'Alterar') && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/grupo-fornecedor/${rowData.grupoFornecedorId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={providers}
      />
    ),
    [providers],
  );

  const fetchFilterOptions = async () => {
    const freq = await api.get('FrequenciasAntecipacoes/Consultar?status=Ativo');
    setFrequencies(freq.data.resposta);
  };

  const fetchProviders = async (
    pageNumber = currentPage,
    currentlyStatus = status,
    itensPage = itensPerPage,
    currentlyAntec = antecipacaoInput,
  ) => {
    setLoading(true);
    const res = await api.get(
      `GruposFornecedores/ConsultarGridCadastro?itensPorPagina=${itensPage}&paginaInicial=${pageNumber}&grupo=${groupInput}&raizCnpjCpf=${cnpjCpfInput}&status=${currentlyStatus}&frequenciaAntecipacaoId=${currentlyAntec}`,
    );
    setPagination(res.data.paginacao);
    if(res.data.paginacao.qtdTotalRegistros > 0){
      setProviders(res.data.resposta);
    } else {
      setProviders([]);
    }
    setLoading(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchProviders(pageNumber);
  };

  useEffect(() => {
    fetchFilterOptions();
    const userPage = JSON.parse(sessionStorage.getItem(TOKEN_PAGINATION)).paginacao.itensPorPagina;
    setItensPerPage(userPage === 0 ? 50 : userPage);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    const delayDebounceFn = setTimeout(() => {
      fetchProviders();
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [cnpjCpfInput, groupInput]);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Grupo Fornecedores"
        back="/app/home"
        create={() => history.push('/app/grupo-fornecedor/cadastrar')}
      />
      <div style={{ background: 'red', width: '100%' }}>VOLTAR</div>
      <div className={classes.content}>
        <div className={classes.rootForm}>
          <Grid container className={classes.searchContainer}>
            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>Grupo</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  value={groupInput}
                  placeholder="Razão Social"
                  onChange={(e) => setGroupInput(e.target.value)}
                  inputProps={{ style: { textTransform: "uppercase" }}}
                />
              </Paper>
            </Grid>
            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>CPF / CNPJ</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  value={cnpjCpfInput}
                  placeholder="CPF/CNPJ"
                  onChange={(e) => setCnpjCpfInput(e.target.value)}
                />
              </Paper>
            </Grid>

            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>Status</label>
              <Paper className={classes.medium} elevation={0}>
                <NativeSelect
                  onChange={(event) => {
                    setStatus(event.target.value);
                    setCurrentPage(1);
                    fetchProviders(1, event.target.value);
                  }}
                  value={status}
                  className={classes.input}
                >
                  <option value="">Todos</option>
                  <option value="ativo">Ativo</option>
                  <option value="inativo">Inativo</option>
                  <option value="pendente">Pendente</option>
                </NativeSelect>
              </Paper>
            </Grid>

            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>Frequência</label>
              <NativeSelect
                className={classes.input}
                value={antecipacaoInput}
                placeholder="Frequência Antecipação"
                onChange={(e) => {
                  setAntecipacaoInput(e.target.value);
                  fetchProviders(1, status, itensPerPage, e.target.value);
                }}
                style={{ marginBottom: '15px', width: '95%' }}
              >
                <option value="">Selecione um</option>
                {frequencies.map((frequency) => (
                  <option
                    key={frequency.frequenciaAntecipacaoId}
                    value={frequency.frequenciaAntecipacaoId}
                  >
                    {frequency.frequencia}
                  </option>
                ))}
              </NativeSelect>
            </Grid>

            <Grid
              item
              xs={2}
              className={classes.item}
              style={{ margin: '0 0 0 auto', display: 'flex', justifyContent: 'flex-end' }}
            >
              <button className={classes.buttonFilter} onClick={() => fetchProviders()}>
                Aplicar Filtro
              </button>
            </Grid>
          </Grid>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {memoizedTable}
              <div className="footer-table">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itensPerPage}
                  totalItemsCount={pagination.qtdTotalRegistros}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
                <div className="select-page">
                  <label>Qtd. por página</label>
                  <NativeSelect
                    onChange={(e) => {
                      fetchProviders(currentPage, status, Number(e.currentTarget.value));
                      setItensPerPage(Number(e.currentTarget.value));
                    }}
                    value={itensPerPage}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </NativeSelect>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
